export default function WhoShouldConsiderData() {
  return {
      title: 'Who Should Consider A Review?',
      paragraphs: [
          'All existing policies should be part of client’s annual reviews to verify the policy still aligns with the client’s goals.',
          'Clients who have had a "life event". Marriage, Divorce, birth of child, birth of grandchild, purchase or sale of a business, improved health since the original policy was purchased, stopped smoking or are in the process of retirement and/or estate planning.',
      ]
  }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/policy-review/WhoShouldConsiderData.js